
import { useI18n } from '../utils/lni18n';
import { useAtom } from 'jotai';
import coursePartCollectionService, { allFoundPartsAtom } from './CoursePartCollectionService';
import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import classes from "../components/SideBar/SideBar.module.scss"
import LnIcon from 'src/components/LnIcon';
import { debouncer } from 'src/utils/debouncer';

export default function AllCourseparts() {

    const { languageService: t } = useI18n();
    const [partsData] = useAtom(allFoundPartsAtom);
    const [searchText, setSearchText] = useState("");
    const debounce = useRef<debouncer | undefined>(undefined);

    const searchParts = (e: React.ChangeEvent<HTMLInputElement>) => {
        const t = e.target.value;
        setSearchText(t);
        if (t.length === 0) {
            coursePartCollectionService.fetchCourseParts("", true);
        } else if (t.length > 2) {
            debounce.current?.debounce(t, true);
        }

    }

    useEffect(() => {
        debounce.current = new debouncer(coursePartCollectionService.fetchCourseParts, 500, coursePartCollectionService);
        return () => debounce.current?.flush();
    }, [])


    return <div>

        <div className={"scrollContent h-100"} aria-live="polite">
            <div className="card-box big-card-box">
                <div className="card-box-title card-title d-flex flex-wrap">
                    <h3>{t.getText("courseparts")}</h3>
                    <div className='m-3 '>
                        <LnIcon name="eye-icon-off" className={`icon-small mr-3`} />
                        {t.getText("coursepart.not.connected.to.course")}
                        <br />
                        <LnIcon name="alert" className='icon-small mr-3' />
                        {t.getText("courspart.not.published")}
                    </div>

                    <div>
                        <input value={searchText} type="text" onChange={(e) => searchParts(e)} placeholder={t.getText("find")} className="input form-control custom-input" />

                    </div>
                </div>
                <div className="card-box-content card-body scroller">

                    <div className="mb-5 row">
                        <div className='col-sm-6 col-xs-12'>
                            <h4>{t.getText("your.courseparts")}</h4>
                            <div className='ml-3 mt-3'>
                                {partsData.OwnedParts.map((part) => (

                                    <div key={part.Id}>
                                        <Link className='position-relative' to={`/coursepart/${part.Id}/texts`} >
                                            {part.ConnectedWithCourse === false && <LnIcon name="eye-icon-off" className={`icon-small ${classes.noCourseIcon}`} />}
                                            {part.Name}

                                            {part.Dirty && <LnIcon name="alert" className='icon-small ml-3' />}
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className='col-sm-6 col-xs-12'>
                            <h4>{t.getText("others")}</h4>
                            <div className='ml-3 mt-3'>
                                {partsData.EditParts.map((part) => (
                                    <div key={part.Id}>
                                        <Link className='position-relative' to={`/coursepart/${part.Id}/texts`} >
                                            {part.ConnectedWithCourse === false && <LnIcon name="eye-icon-off" className={`icon-small ${classes.noCourseIcon}`} />}
                                            {part.Name}

                                            {part.Dirty && <LnIcon name="alert" className='icon-small ml-3' />}
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div></div>
                    </div>


                </div>
            </div>
        </div>
    </div>



}